import React from "react";
import { 
    Background,
    BenefitsTitle,
    RowWrapper,
    ThirtyPercent,
    BenefitImg,
    GlassesImage,
    BenefitText,
    SeventyPercent,
    SpeedImage,
    SavingSpaceImage,
    EnvironmentImage
} from './styles'
import QualityImg from '../../assets/home/quality.svg'
import ChoiceImg from '../../assets/home/choice.svg'
import GlassesImg from '../../assets/home/glasses.svg'
import CostSavingImg from '../../assets/home/cost-savings.svg'
import SwissMapImg from '../../assets/home/swiss-map.svg'
import SpeedImg from '../../assets/home/speed.svg'
import SpeedPng from '../../assets/home/speed.png'
import SavingSpaceImg from '../../assets/home/saving-space.svg'
import SavingSpacePng from '../../assets/home/saving-space.png'
import EnvironmentImg from '../../assets/home/environment.svg'
import EnvironmentPng from '../../assets/home/environment.png'
import { useTranslation } from "react-i18next";

const AboutUs = () => {
    const { t } = useTranslation();

    return(
        <Background>
            <BenefitsTitle id="Benefits"><em>Keg {t("benefits")}</em></BenefitsTitle>
            <RowWrapper>
                <ThirtyPercent>
                    <BenefitImg src={QualityImg} />
                    <BenefitText>{t("constantTemperatureWine")}</BenefitText>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <BenefitImg src={ChoiceImg} />
                    <BenefitText>{t("varietyWinesGlass")}</BenefitText>
                </ThirtyPercent>
                <ThirtyPercent>
                    <GlassesImage src={GlassesImg} />
                </ThirtyPercent>
                <ThirtyPercent>
                    <BenefitImg src={CostSavingImg} cost />
                    <BenefitText right>{t("savingsBulkTransport")}</BenefitText>
                    <br />
                    <br />
                    <img src={SwissMapImg} alt="Swiss map"/>
                </ThirtyPercent>
            </RowWrapper>
            <br />
            <br />
            <br />
            <br />
            <br />
            <RowWrapper>
                <ThirtyPercent flexStart>
                    <BenefitImg src={SpeedImg} />
                </ThirtyPercent>
                <SeventyPercent>
                    <SpeedImage src={SpeedPng} />
                    <BenefitText>{t("upToFourTimesFaster")}</BenefitText>
                </SeventyPercent>
            </RowWrapper>
            <RowWrapper>
                <SeventyPercent>
                    <SavingSpaceImage src={SavingSpacePng} />
                    <BenefitText>{t("kegContains")}</BenefitText>
                </SeventyPercent>
                <ThirtyPercent>
                    <BenefitImg src={SavingSpaceImg} savingSpace/>
                </ThirtyPercent>
            </RowWrapper>
            <RowWrapper reverse>
                <ThirtyPercent flexStart>
                    <BenefitImg src={EnvironmentImg} environment/>
                </ThirtyPercent>
                <SeventyPercent>
                    <EnvironmentImage src={EnvironmentPng} />
                    <BenefitText>{t("serving120CasesMonth")}</BenefitText>
                </SeventyPercent>
            </RowWrapper>
        </Background>
    )
}
export default AboutUs;
